import { addShuttleToBookOffersAction } from "../../../Actions/LogicActions/AddShuttleTransfer/AddShuttleToBookOffersAction";
import { addShuttleTransferContinueClickAction } from "../../../Actions/LogicActions/AddShuttleTransfer/AddShuttleTransferContinueClickAction";
import { deleteShuttleBookOfferAction } from "../../../Actions/LogicActions/AddShuttleTransfer/DeleteShuttleBookOfferAction";
import { getOffersForShuttleAction } from "../../../Actions/LogicActions/AddShuttleTransfer/GetOffersForShuttleAction";
import { updateSelectedShuttlesAction } from "../../../Actions/LogicActions/AddShuttleTransfer/UpdateSelectedShuttlesAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { addShuttleTransferTree } from "../../../Orchestrator/ConstantTree";
import { IAddShuttleOfferActionParams, IDeleteShuttleOfferActionParams, IGetShuttleOfferActionParams, IUpdateSelectedShuttlesActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";
import { AddShuttleTransferContext } from "../Context/AddShuttleTransferContext";

export class AddShuttleTransferInitStep extends StepFlow {
    get stepName() { return "AddShuttleTransferInit_Step"; }

    async onEventSetup(): Promise<void> {

        this.registerEventSubscription(
            _eventBus.on({
                eventName: addShuttleTransferTree.AddShuttle.Back,
                handler: async () => {
                    _eventBus.emit({
                        eventName: "ROUTE_CHANGE",
                        data: "/bookings",
                    });
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IGetShuttleOfferActionParams, void>({
                eventName: addShuttleTransferTree.AddShuttle.SelectStop.Click,
                handler: async (payload) => {
                    if (payload) {
                        getOffersForShuttleAction.setParams(payload.data!);
                        await getOffersForShuttleAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IAddShuttleOfferActionParams, void>({
                eventName: addShuttleTransferTree.AddShuttle.SelectTrip.Click,
                handler: async (payload) => {
                    if (payload) {
                        addShuttleToBookOffersAction.setParams(payload.data!);
                        await addShuttleToBookOffersAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IDeleteShuttleOfferActionParams, void>({
                eventName: addShuttleTransferTree.AddShuttle.DeleteOffer.Click,
                handler: async (payload) => {
                    if (payload) {
                        deleteShuttleBookOfferAction.setParams(payload.data!);
                        await deleteShuttleBookOfferAction.execute();
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: addShuttleTransferTree.AddShuttle.Continue.Click,
                handler: async (payload: any) => {
                    addShuttleTransferContinueClickAction.setParams(payload.data!);
                    await addShuttleTransferContinueClickAction.execute();

                    if (addShuttleTransferContinueClickAction.result === "success") {
                        setTimeout(() => {
                            _eventBus.emit({
                                eventName: "ROUTE_CHANGE",
                                data: "/checkout"
                            });
                        }, 0);
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<IUpdateSelectedShuttlesActionParams, void>({
                eventName: addShuttleTransferTree.AddShuttle.UpdateSelectedShuttles.Click,
                handler: async (payload) => {
                    if (payload) {
                        updateSelectedShuttlesAction.setParams(payload.data!);
                        await updateSelectedShuttlesAction.execute();
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        this.setCtx("addShuttleTransferContext", AddShuttleTransferContext)
        console.log("Add Shuttle Transfer Initialize.....")
    }

}

export const AddShuttleTransferInitStepDeclaration = new StepDefinition({
    stepName: "AddShuttleTransferInit_Step",
    stepClass: AddShuttleTransferInitStep
});